import getEnvironment from "../helpers/getEnvironment";
import { getBatteryGradeData } from "../utilities/getBatteryGradeData";
import {
  getBeautyImagesCount,
  getDamageImagesCount,
} from "../utilities/getImagesCount";
import { EvBattery } from "../vehicleDetails/vehicle-details.type";
import { formatDate } from "./pushPageView";
import { Image } from "../vehicleDetails/vehicle-details-dto.type";

interface EventType {
  action: string;
  category: string;
  label: string;
  name: string;
  section: string;
  value: string;
  type?: string;
}

export interface AnalyticsData {
  saleCode: string;
  vrm: string;
  lotNumber: string;
  saleTypeCode?: string;
  saleTypeName?: string;
  location: string;
  startDate: string;
  endDate: string;
  vehicleId: string;
  hpi: boolean;
  images: Image[];
  mechanicalReportAnalyticsData: string;
  vehicleType: string;
  evBattery: EvBattery;
}

const pushBatteryGradeData = (
  event: EventType,
  analyticsData: AnalyticsData
) => {
  if (getEnvironment() === "localhost") {
    return;
  }
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    digitalData.push({
      event,
      product: {
        vehicle: [
          {
            vin: "", // not available
            vrm: analyticsData.vrm,
            unitPrice: "", // not available
            dealerId: "", // not available
            saleCode: analyticsData.saleCode,
            lotCode: analyticsData.lotNumber,
            saleCountry: "gb",
            saleType: analyticsData.saleTypeCode,
            saleBranch: analyticsData.location,
            saleStartDate: formatDate(analyticsData.startDate),
            saleEndDate: formatDate(analyticsData.endDate),
            vehId: analyticsData.vehicleId,
            hpiSpecFlag: analyticsData.hpi
              ? "hpi-available"
              : "hpi-is-not-available",
            mechReportCombo: analyticsData.mechanicalReportAnalyticsData,
            vehicleType: analyticsData.vehicleType,
            batteryGrade: getBatteryGradeData(analyticsData.evBattery),
          },
        ],
        image: {
          damageImageFlag:
            getDamageImagesCount(analyticsData.images) > 0
              ? "damage-images-available"
              : "damage-images-not-available",
          totalImagesAvailable: analyticsData.images?.length || 0,
          totalDamageImagesAvailable: getDamageImagesCount(
            analyticsData.images
          ),
          totalBeautyImagesAvailable: getBeautyImagesCount(
            analyticsData.images
          ),
        },
      },
    });
  }
};

export default pushBatteryGradeData;
